import { CoinType } from '@/zustand-store/coin/useCoinStore';

export const CongratulationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1289_13029)">
        <path
          d="M3.86732 7.5332L1.33398 14.6665L8.46732 12.1399"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.66602 2H2.67268"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.666 5.33398H14.6727"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 1.33398H10.0067"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.666 13.334H14.6727"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6673 1.33398L13.174 1.83398C12.7489 1.97558 12.3862 2.26041 12.1479 2.6398C11.9095 3.01919 11.8104 3.46958 11.8673 3.91398C11.934 4.48732 11.4873 5.00065 10.9007 5.00065H10.6473C10.074 5.00065 9.58065 5.40065 9.47398 5.96065L9.33398 6.66732"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6673 8.6663L14.1207 8.4463C13.5473 8.21963 12.9073 8.57963 12.8007 9.18629C12.7273 9.65296 12.3207 9.99963 11.8473 9.99963H11.334"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33333 1.33398L7.55333 1.88065C7.78 2.45398 7.42 3.09398 6.81333 3.20065C6.34667 3.26732 6 3.68065 6 4.15398V4.66732"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33334 8.66635C8.62001 9.95302 9.22001 11.4464 8.66668 11.9997C8.11334 12.553 6.62001 11.953 5.33334 10.6664C4.04668 9.37969 3.44668 7.88635 4.00001 7.33302C4.55334 6.77969 6.04668 7.37969 7.33334 8.66635Z"
          stroke="#9FF4CF"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1289_13029">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M10.9353 11.3338H4.40195C4.29587 11.3338 4.19412 11.2917 4.11911 11.2167C4.0441 11.1417 4.00195 11.0399 4.00195 10.9338V4.40049C4.00195 4.2944 4.0441 4.19266 4.11911 4.11765C4.19412 4.04263 4.29587 4.00049 4.40195 4.00049H10.9353C11.0414 4.00049 11.1431 4.04263 11.2181 4.11765C11.2931 4.19266 11.3353 4.2944 11.3353 4.40049V10.9338C11.3353 11.0399 11.2931 11.1417 11.2181 11.2167C11.1431 11.2917 11.0414 11.3338 10.9353 11.3338Z"
      stroke="#9192A0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0013 4.00033V1.06699C8.0013 0.960906 7.95916 0.859164 7.88415 0.784149C7.80913 0.709135 7.70739 0.666992 7.6013 0.666992H1.06797C0.961882 0.666992 0.860141 0.709135 0.785126 0.784149C0.710112 0.859164 0.667969 0.960906 0.667969 1.06699V7.60033C0.667969 7.70641 0.710112 7.80815 0.785126 7.88317C0.860141 7.95818 0.961882 8.00033 1.06797 8.00033H4.0013"
      stroke="#9192A0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckedIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3024_36273)">
      <g filter="url(#filter0_dii_3024_36273)">
        <path
          d="M25.088 49.3333L9.33325 34.4144L16.513 27.6156L25.088 35.7598L50.1535 12L57.3333 18.7988L25.088 49.3333Z"
          fill="#17E1BD"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dii_3024_36273"
        x="-0.666748"
        y="2"
        width="68"
        height="57.3333"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0369792 0 0 0 0 0.8875 0 0 0 0 0.540488 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3024_36273"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3024_36273"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1" dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.642882 0 0 0 0 0.958333 0 0 0 0 0.902114 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_3024_36273"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0388194 0 0 0 0 0.716667 0 0 0 0 0.595862 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_3024_36273"
          result="effect3_innerShadow_3024_36273"
        />
      </filter>
      <clipPath id="clip0_3024_36273">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OpenInNewIcon = ({ color = '#9192A0' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10 2H14V6"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66663 9.33333L14 2"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MemeIcon = () => {
  const id = Math.random();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <g clipPath={`url(#clip0_1495_9000_${id})`}>
        <path
          d="M10.0002 9.91659C9.35581 9.91659 8.8335 9.39427 8.8335 8.74992C8.8335 8.10557 9.35581 7.58325 10.0002 7.58325C10.6445 7.58325 11.1668 8.10557 11.1668 8.74992C11.1668 9.39427 10.6445 9.91659 10.0002 9.91659Z"
          stroke="#080A14"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.66683 12.8334C10.8885 12.8334 13.5002 10.2217 13.5002 7.00008C13.5002 3.77842 10.8885 1.16675 7.66683 1.16675C4.44517 1.16675 1.8335 3.77842 1.8335 7.00008C1.8335 10.2217 4.44517 12.8334 7.66683 12.8334Z"
          stroke="#080A14"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.62516 5.25008C5.46408 5.25008 5.3335 5.1195 5.3335 4.95841C5.3335 4.79733 5.46408 4.66675 5.62516 4.66675C5.78624 4.66675 5.91683 4.79733 5.91683 4.95841C5.91683 5.1195 5.78624 5.25008 5.62516 5.25008Z"
          fill="#080A14"
          stroke="#080A14"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.70841 5.25008C9.54736 5.25008 9.41675 5.1195 9.41675 4.95841C9.41675 4.79733 9.54736 4.66675 9.70841 4.66675C9.86947 4.66675 10.0001 4.79733 10.0001 4.95841C10.0001 5.1195 9.86947 5.25008 9.70841 5.25008Z"
          fill="#080A14"
          stroke="#080A14"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.62516 5.25008C5.46408 5.25008 5.3335 5.1195 5.3335 4.95841C5.3335 4.79733 5.46408 4.66675 5.62516 4.66675C5.78624 4.66675 5.91683 4.79733 5.91683 4.95841C5.91683 5.1195 5.78624 5.25008 5.62516 5.25008Z"
          fill="#080A14"
          stroke="#080A14"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.70841 5.25008C9.54736 5.25008 9.41675 5.1195 9.41675 4.95841C9.41675 4.79733 9.54736 4.66675 9.70841 4.66675C9.86947 4.66675 10.0001 4.79733 10.0001 4.95841C10.0001 5.1195 9.86947 5.25008 9.70841 5.25008Z"
          fill="#080A14"
          stroke="#080A14"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={`clip0_1495_9000_${id}`}>
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0.666748)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <path
        d="M10 3L4.75 9L2.5 6.75"
        stroke="#9FF4CF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <path
        d="M9.0625 4.50001H8.5V3.40548C8.5 2.17032 7.51562 1.14376 6.28047 1.12501C5.02891 1.10861 4 2.12814 4 3.37501V4.50001H3.4375C2.92188 4.50001 2.5 4.92189 2.5 5.43751V9.93751C2.5 10.4531 2.92188 10.875 3.4375 10.875H9.0625C9.57812 10.875 10 10.4531 10 9.93751V5.43751C10 4.92189 9.57812 4.50001 9.0625 4.50001ZM6.57812 7.42501V9.03751C6.57812 9.21329 6.44219 9.36564 6.26641 9.37501C6.07891 9.38439 5.92188 9.23439 5.92188 9.04689V7.42501C5.65234 7.29376 5.47422 7.00782 5.50234 6.68204C5.53516 6.31876 5.83281 6.02814 6.19609 6.00236C6.63438 5.97189 7 6.31876 7 6.75001C7 7.04767 6.82891 7.30314 6.57812 7.42501ZM7.84375 4.50001H4.65625V3.37501C4.65625 2.95079 4.82266 2.55236 5.125 2.25001C5.42734 1.94767 5.82578 1.78126 6.25 1.78126C6.67422 1.78126 7.07266 1.94767 7.375 2.25001C7.67734 2.55236 7.84375 2.95079 7.84375 3.37501V4.50001Z"
        fill="#F79009"
      />
    </svg>
  );
};

export const BadgeCoin = ({ tag, height = '24px' }) => {
  const TAG_COIN_COLOR = (opacity = '0.80') => {
    return {
      [CoinType.AGENT]: `rgba(255,175,20,${opacity})`,
      [CoinType.DEFAI]: `rgba(188,250,68,${opacity})`,
      [CoinType.MEME]: `rgba(163,130,255,${opacity})`,
    };
  };

  return (
    <div
      className="rounded w-fit p-[2px] border border-dashed border-[rgba(255,175,20,0.97)]"
      style={{
        borderColor: TAG_COIN_COLOR('0.97')[tag],
      }}
    >
      <div
        style={{
          height,
          boxShadow: `0px 0px 12px 0px ${
            TAG_COIN_COLOR()[tag] || 'rgba(255,175,20,0.8)'
          }`,
          background: TAG_COIN_COLOR('1')[tag],
        }}
        className="rounded text-[9px] md:text-[10px] w-fit text-[#080A14] uppercase px-[2px] flex items-center justify-center bg-[#aee67f]"
      >
        {/* <MemeIcon /> */}
        <span className="ml-1 uppercase">{tag}</span>
      </div>
    </div>
  );
};

export function SettingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 20 20"
      fill="none"
      className="cursor-pointer"
    >
      <path
        d="M16.2617 10C16.2617 9.17969 16.7734 8.48047 17.5 8.19922C17.3086 7.39844 16.9922 6.64844 16.5742 5.96875C16.3242 6.07812 16.0586 6.13672 15.7891 6.13672C15.2969 6.13672 14.8047 5.94922 14.4258 5.57422C13.8438 4.99219 13.7148 4.13672 14.0273 3.42578C13.3516 3.00781 12.5977 2.69141 11.8008 2.5C11.5234 3.22266 10.8203 3.73828 10 3.73828C9.17969 3.73828 8.47656 3.22266 8.19922 2.5C7.39844 2.69141 6.64844 3.00781 5.96875 3.42578C6.28516 4.13281 6.15234 4.99219 5.57031 5.57422C5.19531 5.94922 4.69922 6.13672 4.20703 6.13672C3.9375 6.13672 3.67188 6.08203 3.42187 5.96875C3.00781 6.65234 2.69141 7.40234 2.5 8.20312C3.22266 8.48047 3.73828 9.17969 3.73828 10.0039C3.73828 10.8242 3.22656 11.5234 2.50391 11.8047C2.69531 12.6055 3.01172 13.3555 3.42969 14.0352C3.67969 13.9258 3.94531 13.8711 4.21094 13.8711C4.70313 13.8711 5.19531 14.0586 5.57422 14.4336C6.15234 15.0117 6.28516 15.8711 5.97266 16.5781C6.65234 16.9961 7.40625 17.3125 8.20312 17.5039C8.48047 16.7812 9.17969 16.2695 10 16.2695C10.8203 16.2695 11.5195 16.7812 11.7969 17.5039C12.5977 17.3125 13.3477 16.9961 14.0273 16.5781C13.7148 15.8711 13.8477 15.0156 14.4258 14.4336C14.8008 14.0586 15.293 13.8711 15.7891 13.8711C16.0547 13.8711 16.3242 13.9258 16.5703 14.0352C16.9883 13.3555 17.3047 12.6016 17.4961 11.8047C16.7773 11.5234 16.2617 10.8242 16.2617 10ZM10.0352 13.1211C8.30469 13.1211 6.91016 11.7188 6.91016 9.99609C6.91016 8.27344 8.30469 6.87109 10.0352 6.87109C11.7656 6.87109 13.1602 8.27344 13.1602 9.99609C13.1602 11.7188 11.7656 13.1211 10.0352 13.1211Z"
        fill="#9192A0"
      />
    </svg>
  );
}

export function ArrowRightIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="ml-1"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.87494 3.99408C6.5495 4.31951 6.5495 4.84715 6.87494 5.17259L11.7023 10L6.87493 14.8274C6.5495 15.1528 6.5495 15.6805 6.87493 16.0059C7.20037 16.3314 7.72801 16.3314 8.05345 16.0059L12.8809 11.1785C13.5317 10.5276 13.5317 9.47236 12.8809 8.82149L8.05345 3.99408C7.72801 3.66864 7.20037 3.66864 6.87494 3.99408Z"
        fill="#9192A0"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99998 13.3334H14M2 13.3334H3.11636C3.44248 13.3334 3.60554 13.3334 3.75899 13.2966C3.89504 13.2639 4.0251 13.21 4.1444 13.1369C4.27895 13.0545 4.39425 12.9392 4.62486 12.7086L13 4.3334C13.5523 3.78112 13.5523 2.88569 13 2.3334C12.4477 1.78112 11.5523 1.78112 11 2.3334L2.62484 10.7086C2.39424 10.9392 2.27894 11.0545 2.19648 11.189C2.12338 11.3083 2.0695 11.4384 2.03684 11.5744C2 11.7279 2 11.8909 2 12.2171V13.3334Z"
        stroke="#E4775D"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
